import type { BaseSlideProps, ComparisonContent } from './SlideLayout.types';
import { inlineMarkdown } from '@/lib/markdown';

export function ComparisonSlide({ title, content, accentColor }: BaseSlideProps) {
  const { comparison } = content as ComparisonContent;
  const { itemA, itemB } = comparison;

  return (
    <div
      className="slide-content animate-fade-in-up"
      style={{ '--color-accent': accentColor } as React.CSSProperties}
    >
      <h2 className="text-4xl font-serif font-bold mb-8 text-center accent-text">
        {title}
      </h2>

      <div className="split-layout">
        {/* Item A */}
        <div className="card accent-border-left">
          <div className="flex items-center justify-between mb-4">
            <h3 className="font-serif font-semibold text-2xl accent-text">
              {itemA.label}
            </h3>
          </div>

          <p className="text-slate-700 dark:text-slate-300 mb-4 leading-relaxed"
             dangerouslySetInnerHTML={{ __html: inlineMarkdown(itemA.description) }} />

          {itemA.examples && itemA.examples.length > 0 && (
            <div className="mt-4 space-y-2">
              <p className="text-sm font-medium text-slate-600 dark:text-slate-400">
                Examples:
              </p>
              <ul className="space-y-2">
                {itemA.examples.map((example, idx) => (
                  <li key={idx} className="text-sm text-slate-600 dark:text-slate-400 flex">
                    <span className="accent-text mr-2">→</span>
                    <span dangerouslySetInnerHTML={{ __html: inlineMarkdown(example) }} />
                  </li>
                ))}
              </ul>
            </div>
          )}

          {itemA.metaphor && (
            <div className="mt-4 pt-4 border-t border-slate-200 dark:border-slate-700">
              <p className="text-xs text-slate-500 dark:text-slate-400 italic"
                 dangerouslySetInnerHTML={{ __html: inlineMarkdown(itemA.metaphor) }} />
            </div>
          )}
        </div>

        {/* Item B */}
        <div className="card accent-border-left">
          <div className="flex items-center justify-between mb-4">
            <h3 className="font-serif font-semibold text-2xl accent-text">
              {itemB.label}
            </h3>
          </div>

          <p className="text-slate-700 dark:text-slate-300 mb-4 leading-relaxed"
             dangerouslySetInnerHTML={{ __html: inlineMarkdown(itemB.description) }} />

          {itemB.examples && itemB.examples.length > 0 && (
            <div className="mt-4 space-y-2">
              <p className="text-sm font-medium text-slate-600 dark:text-slate-400">
                Examples:
              </p>
              <ul className="space-y-2">
                {itemB.examples.map((example, idx) => (
                  <li key={idx} className="text-sm text-slate-600 dark:text-slate-400 flex">
                    <span className="accent-text mr-2">→</span>
                    <span dangerouslySetInnerHTML={{ __html: inlineMarkdown(example) }} />
                  </li>
                ))}
              </ul>
            </div>
          )}

          {itemB.metaphor && (
            <div className="mt-4 pt-4 border-t border-slate-200 dark:border-slate-700">
              <p className="text-xs text-slate-500 dark:text-slate-400 italic"
                 dangerouslySetInnerHTML={{ __html: inlineMarkdown(itemB.metaphor) }} />
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
